<style lang="scss">
#debug {
  border-top: 1px dashed red;
  border-left: 1px dashed red;
  padding: 10px;
  position: fixed;
  background-color: #fff;
  bottom: 0;
  right: 0;
  max-height: 100vh;
  max-width: 20vw;
  overflow: scroll;
  border-top-left-radius: 10px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
  z-index: 10000000;
  .storestatebutton {
    text-decoration: underline;
    cursor: pointer;
  }

  button,
  select {
    width: 100%;
    padding: 5px;
    margin-bottom: 10px;
  }
}
</style>

<template>
  <teleport to="body">
    <div id="debug">
      Debug: <br />
      <!-- Screenwidth: {{ width }}px<br />
      Menustate: {{ menustate }} <br />
      Searchstate: {{ searchstate }}<br /> -->

      <span class="storestatebutton" @click="toggleState" v-if="!showState">Store</span>
      <span class="storestatebutton" @click="toggleState" v-if="showState">Store</span><br />
      <pre v-if="showState">{{ store.state }}</pre>
      <span class="storestatebutton" @click="toggleRoute" v-if="!showRoute">RouteMeta</span>
      <span class="storestatebutton" @click="toggleRoute" v-if="showRoute">RouteMeta</span><br />
      <pre v-if="showRoute">{{ route.meta }}</pre>

      <span class="storestatebutton" @click="toggleAuth" v-if="!showAuth">Auth</span>
      <span class="storestatebutton" @click="toggleAuth" v-if="showAuth">Auth</span><br />
      <br v-if="showAuth" />
      <pre v-if="showAuth">
        <button @click="resetSession">Reset Session</button><br />
        {{ store.state.auth }}
      </pre>

      <span class="storestatebutton" @click="togglePerso" v-if="!showPerso">Personification</span>
      <span class="storestatebutton" @click="togglePerso" v-if="showPerso">Personification</span><br />
      <div v-if="showPerso">
        <select v-model="persoid" v-if="!impersonating">
          <option :value="user.id" :key="user.id" v-for="user of users">
            {{ user.firstname }} {{ user.lastname }} ({{ user.rolename }})
          </option></select
        ><br />
        <button v-if="persoid" @click="impersonate(persoid)">Impersonifizieren</button>
        <div style="color: red; font-weight: bold" v-if="impersonating">IMPERSONATING</div>
        <button @click="depersonify" v-if="impersonating">Back to original User</button>
      </div>
    </div>
  </teleport>
</template>

<script lang="ts">
import { computed, defineComponent, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
export default defineComponent({
  setup() {
    const store = useStore();
    const showState = ref(false);
    const showRoute = ref(false);
    const showAuth = ref(false);
    const showPerso = ref(false);
    const route = useRoute();
    const router = useRouter();
    const validtoken = computed(() => store.getters.validToken('refreshToken'));
    const users = ref();
    const persoid = ref<number>();
    const impersonating = ref(false);

    const resetSession = () => {
      localStorage.removeItem('session');
      setTimeout(() => {
        window.location.reload();
      }, 500);
    };

    onMounted(() => {
      store.dispatch('fetchAllWorkers').then((res: any) => {
        users.value = res;
      });

      impersonating.value = localStorage.getItem('originalsession') != null;
    });

    const impersonate = (id: number | undefined) => {
      if (id) {
        impersonating.value = true;
        store.dispatch('impersonify', id);
      }
    };

    const depersonify = () => {
      store.dispatch('depersonify');
      impersonating.value = false;
    };

    return {
      impersonate,
      depersonify,
      users,
      persoid,
      impersonating,
      // width: computed(() => store.state.windowsize),
      // menustate: computed(() => store.state.menustate),
      // searchstate: computed(() => store.state.searchstate),

      showState,
      store,
      route,
      showRoute,
      showAuth,
      showPerso,
      validtoken,
      resetSession,
      toggleRoute: () => (showRoute.value = !showRoute.value),
      toggleState: () => (showState.value = !showState.value),
      toggleAuth: () => (showAuth.value = !showAuth.value),
      togglePerso: () => (showPerso.value = !showPerso.value),
    };
  },
});
</script>
